import { createAsyncThunk } from '@reduxjs/toolkit';
import { EmailApi } from '../http';
import { IEmailQuery } from '../models';

const emailApi = new EmailApi();

export const fetchEmailCreate = createAsyncThunk(
  'email/create',
  async (body: IEmailQuery, { rejectWithValue }) => {
    try {
      return await emailApi.createOne(body);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
